import { useJsApiLoader, type LoadScriptProps } from '@react-google-maps/api'

import { GOOGLE_MAPS_KEY } from '../../infra/environment'

const LIBRARIES: LoadScriptProps['libraries'] = ['places']

export function useGoogleMaps() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: GOOGLE_MAPS_KEY,
    libraries: LIBRARIES,
  })

  return { isLoaded }
}
